export const EDIT_PROFILE = "EDIT_PROFILE"
export const PROFILE_SUCCESS = "PROFILE_SUCCESS"
export const PROFILE_ERROR = "PROFILE_ERROR"
export const RESET_PROFILE_FLAG = "RESET_PROFILE_FLAG";
export const CHANGE_AVARTAR_PROFILE = "CHANGE_AVARTAR_PROFILE";
export const GET_PROFILE = "GET_PROFILE";